/**
 * @Relay no-runtime
 */
/**
 * @graphql cc
 */
import graphql from 'graphql-tag';
import { useMemo } from 'react';
import {
	// eslint-disable-next-line graphql-relay-compat/no-import-apollo-functions -- Read http://go/cfe-no-import-apollo-functions
	useQuery,
} from 'react-apollo';

import { usePageSpaceKey } from '@confluence/page-context';

import { normalizeSpaceAdminData } from '../normalizers/normalizeSpaceAdminData';

import type {
	useSpaceAdminDetailsPanelSpaceAdminQuery as useSpaceAdminDetailsPanelSpaceAdminQuery$data,
	useSpaceAdminDetailsPanelSpaceAdminQueryVariables as useSpaceAdminDetailsPanelSpaceAdminQuery$variables,
} from './__types__/useSpaceAdminDetailsPanelSpaceAdminQuery';

const useSpaceAdminDetailsPanelSpaceAdminQuery = graphql`
	query useSpaceAdminDetailsPanelSpaceAdminQuery($spaceKey: String!) {
		space(key: $spaceKey) {
			id
			currentUser {
				isAdmin
			}
		}
	}
`;
export const useSpaceAdmin = () => {
	const [spaceKey] = usePageSpaceKey();
	const { data, loading, error, refetch } = useQuery<
		useSpaceAdminDetailsPanelSpaceAdminQuery$data,
		useSpaceAdminDetailsPanelSpaceAdminQuery$variables
	>(useSpaceAdminDetailsPanelSpaceAdminQuery, {
		skip: !spaceKey,
		variables: {
			spaceKey: spaceKey ?? '',
		},
	});
	const normalizedData = useMemo(() => normalizeSpaceAdminData(data), [data]);

	return {
		data: normalizedData,
		loading,
		error,
		refetch,
	};
};
